import React, { useState, lazy, Suspense, useEffect } from "react";
import "../src/App.css";
import Header from "./components/Header/index";
import Body from "./components/Body/Body";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import MediaQuery from "react-responsive";
import { CookieSetting } from "cookiesetting-component";

const Revolution = lazy(() =>
  import("./components/Revolution/Revolution.js")
);
const Footer = lazy(() =>
  import("./components/CommenFooterComponent/index.js")
);
const Testimonial = lazy(() =>
  import("./components/Testimonials/Testimonials.js")
);

const Russ = lazy(() => import("./components/RussAnderson/Russ.js"));
const Homeowner = lazy(() => import("./components/Homeowner/Homeowner.js"));
export default function App() {

  const [showOtherComponents, setShowOtherComponents] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.offsetHeight;
      const scrollPosition =
        window.scrollY ||
        window.pageYOffset ||
        document.documentElement.scrollTop;
      const maxScroll = documentHeight - windowHeight;
      const percentage = (scrollPosition / maxScroll) * 100;

      if (percentage > 50) {
        setShowOtherComponents(true);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Clean up the scroll listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <CacheBuster
      currentVersion={appversion.version}
      isEnabled={true} // If false, the library is disabled.
      isVerboseMode={false} // If true, the library writes verbose logs to console.
      // loadingComponent={<Loading />} // If not pass, nothing appears at the time of new version check.
      metaFileDirectory={process.env.PUBLIC_URL} // If public assets are hosted somewhere other than root on your server.
    >
      <div className="bodyContainer">

        <>
          <MediaQuery minWidth={992}>
            <Header fetchpriority="high" />
            <>
              <Body />
              <Suspense fallback={<div />}>
                <Revolution />
              </Suspense>
              {showOtherComponents && (
                <>
                  <Suspense fallback={<div />}>
                    <Homeowner />
                  </Suspense>
                  <Suspense fallback={<div />}>
                    <Testimonial />
                  </Suspense>
                  <Suspense fallback={<div />}>
                    <Russ />
                  </Suspense>

                  <Suspense fallback={<div />}>
                    <Footer />
                  </Suspense>
                </>
              )}
            </>
          </MediaQuery>
          <MediaQuery maxWidth={991}>
            <Header fetchpriority="high" />
            <Body fetchpriority="high" />
            <Suspense fallback={<div />}>
              <Revolution />
            </Suspense>
            <>

              {showOtherComponents && (
                <>
                  <Suspense fallback={<div />}>
                    <Homeowner />
                  </Suspense>
                  <Suspense fallback={<div />}>
                    <Testimonial />
                  </Suspense>
                  <Suspense fallback={<div />}>
                    <Russ />
                  </Suspense>
                  <Suspense fallback={<div />}>
                    <Footer />
                  </Suspense>
                </>
              )}
            </>
          </MediaQuery>
        </>
        <CookieSetting
          privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK}
          configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
          analytics={process.env.REACT_APP_ANALYTICS_PATH}
        />

      </div>
    </CacheBuster>
  );
}
